import type { HttpClient } from '@/services/http/HttpClient';
import type { AjaxProblem } from '@/types/Request/AjaxProblem';
import type { ErrorLike } from '@/types/Request/ErrorLike';
import type { ThrownLiteral } from '@/types/Request/ThrownLiteral';
import type { UnhandledRejection } from '@/types/Request/UnhandledRejection';

export class ErrorRepository {
    client: HttpClient;

    constructor(client: HttpClient) {
        this.client = client;
    }

    async sendAjaxProblem(ajaxProblem: AjaxProblem) {
        return this.client.post('/v1/error/ajax-problem', ajaxProblem);
    }

    async sendErrorLike(error: ErrorLike) {
        return this.client.post('/v1/error/runtime', error);
    }

    async sendThrownLiteral(literal: ThrownLiteral) {
        return this.client.post('/v1/error/literal', literal);
    }

    async sendUnhandledRejection(rejection: UnhandledRejection) {
        return this.client.post('/v1/error/rejection', rejection);
    }
}
